import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, CardActionArea, Typography, Stack, Button, Avatar } from '@mui/material';
import { FaFolder } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { fetchAllProjects } from '../../controllers/projectsController';
import { resolveProjectsAssetUrl } from '../../api/httpClientProjects';
import { resolveGroupsAssetUrl } from '../../api/httpClientGroups';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SonProjeler = () => {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        fetchAllProjects({ pageNumber: 1, pageSize: 5 })
            .then(({ data }) => {
                if (!active) return;
                setProjects(Array.isArray(data) ? data : []);
            })
            .catch((e) => {
                if (active) setError(e?.message || 'Projeler alınamadı');
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const months = [
            'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
            'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
        ];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    return (
        <Card sx={{ flex: '0 0 calc(50% - 16px)', minWidth: 300, border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
            <CardContent sx={{ p: 2.5 }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: '50%',
                                backgroundColor: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <FaFolder style={{ fontSize: '18px', color: '#0E4D94' }} />
                        </Box>
                        <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#444444' }}>
                            Son Projeler
                        </Typography>
                    </Stack>
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => navigate('/projects')}
                        sx={{
                            textTransform: 'none',
                            fontSize: '13px',
                            fontWeight: 500,
                            backgroundColor: 'transparent',
                            color: '#0E4D94',
                            textDecoration: 'underline',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Tüm Projeler
                    </Button>
                </Stack>

                {error ? (
                    <Typography color="error" sx={{ fontSize: '14px' }}>{error}</Typography>
                ) : loading ? (
                    <Stack spacing={1.5}>
                        {Array.from({ length: 4 }).map((_, index) => (
                            <Card
                                key={`skeleton-${index}`}
                                sx={{
                                    width: '100%',
                                    border: 'none',
                                    boxShadow: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5,
                                    }}
                                >
                                    <Skeleton width={120} height={80} borderRadius={4} />
                                    <Box sx={{ flex: 1 }}>
                                        <Skeleton width={100} height={14} style={{ marginBottom: 8 }} />
                                        <Skeleton width="80%" height={18} style={{ marginBottom: 6 }} />
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Skeleton circle width={24} height={24} />
                                            <Skeleton width={80} height={14} />
                                        </Box>
                                    </Box>
                                    <Skeleton width={20} height={20} />
                                </Box>
                            </Card>
                        ))}
                    </Stack>
                ) : projects.length === 0 ? (
                    <Typography sx={{ fontSize: '14px', color: '#a3a3a3', textAlign: 'center', py: 2 }}>
                        Henüz proje bulunmamaktadır.
                    </Typography>
                ) : (
                    <Stack spacing={1.5}>
                        {projects.map((project) => {
                            const leader = Array.isArray(project.groupMembers)
                                ? project.groupMembers.find((m) => m.isLeader)
                                : null;
                            return (
                                <CardActionArea
                                    key={project.id}
                                    onClick={() => navigate(`/projects/${project.id}`)}
                                    sx={{
                                        borderRadius: '8px',
                                        '&:hover': {
                                            backgroundColor: '#f9f9f9',
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            p: 1,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 120,
                                                height: 80,
                                                borderRadius: '4px',
                                                overflow: 'hidden',
                                                flexShrink: 0,
                                                backgroundColor: '#f5f5f5',
                                            }}
                                        >
                                            {project.coverImageUrl ? (
                                                <Box
                                                    component="img"
                                                    src={resolveProjectsAssetUrl(project.coverImageUrl)}
                                                    alt={project.name}
                                                    sx={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain',
                                                    }}
                                                />
                                            ) : (
                                                <Box
                                                    sx={{
                                                        width: '100%',
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#f5f5f5',
                                                    }}
                                                />
                                            )}
                                        </Box>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography sx={{ fontSize: '12px', color: '#666666', mb: 0.5 }}>
                                                {formatDate(project.createdAtUtc)}
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#1a1a1a', mb: 1, lineHeight: 1.3 }}>
                                                {project.name}
                                            </Typography>
                                            {leader && (
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Avatar
                                                        src={leader.profilePictureUrl ? resolveGroupsAssetUrl(leader.profilePictureUrl) : undefined}
                                                        sx={{ width: 24, height: 24 }}
                                                    >
                                                        {leader.fullName?.charAt(0) || '?'}
                                                    </Avatar>
                                                    <Typography sx={{ fontSize: '13px', color: '#666666' }}>
                                                        {leader.fullName || ''}
                                                    </Typography>
                                                </Stack>
                                            )}
                                        </Box>
                                        <ChevronRightIcon sx={{ fontSize: 20, color: '#0E4D94', flexShrink: 0 }} />
                                    </Box>
                                </CardActionArea>
                            );
                        })}
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
};

export default SonProjeler;
